"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.operations = void 0;
var balance_1 = require("./balance");
var block_1 = require("./block");
var defi_1 = require("./defi");
var events_1 = require("./events");
var ipfs_1 = require("./ipfs");
var nft_1 = require("./nft");
var resolve_1 = require("./resolve");
var token_1 = require("./token");
var getWalletTokenTransfersOperation_1 = require("./token/getWalletTokenTransfersOperation");
var transaction_1 = require("./transaction");
var utils_1 = require("./utils");
var runContractFunctionOperation_1 = require("./utils/runContractFunctionOperation");
exports.operations = [
    utils_1.endpointWeightsOperation,
    block_1.getBlockOperation,
    events_1.getContractEventsOperation,
    events_1.getContractLogsOperation,
    nft_1.getContractNFTsOperation,
    block_1.getDateToBlockOperation,
    nft_1.getMultipleNFTsOperation,
    balance_1.getNativeBalanceOperation,
    nft_1.getNFTContractMetadataOperation,
    nft_1.getNFTContractTransfersOperation,
    nft_1.getNFTLowestPriceOperation,
    nft_1.getNFTMetadataOperation,
    nft_1.getNFTOwnersOperation,
    nft_1.getNFTTokenIdOwnersOperation,
    nft_1.getNFTTradesOperation,
    nft_1.getNFTTransfersByBlockOperation,
    nft_1.getNFTTransfersFromToBlockOperation,
    nft_1.getNFTTransfersOperation,
    defi_1.getPairAddressOperation,
    defi_1.getPairReservesOperation,
    token_1.getTokenAllowanceOperation,
    token_1.getTokenMetadataBySymbolOperation,
    token_1.getTokenMetadataOperation,
    token_1.getTokenPriceOperation,
    token_1.getTokenTransfersOperation,
    transaction_1.getTransactionOperation,
    nft_1.getWalletNFTCollectionsOperation,
    nft_1.getWalletNFTsOperation,
    nft_1.getWalletNFTTransfersOperation,
    token_1.getWalletTokenBalancesOperation,
    getWalletTokenTransfersOperation_1.getWalletTokenTransfersOperation,
    transaction_1.getWalletTransactionsOperation,
    transaction_1.getWalletTransactionsVerboseOperation,
    resolve_1.resolveAddressOperation,
    resolve_1.resolveDomainOperation,
    nft_1.reSyncMetadataOperation,
    runContractFunctionOperation_1.runContractFunctionOperation,
    nft_1.searchNFTsOperation,
    nft_1.syncNFTContractOperation,
    ipfs_1.uploadFolderOperation,
    utils_1.web3ApiVersionOperation,
];
//# sourceMappingURL=operations.js.map